/** @jsx jsx */

import * as React from "react";
import { AnyAction } from "redux";
import CustomSelect from "../../CustomSelect";
import Dropdown from "../../Dropdown";
import TextInput from "../../TextInput";
import TypeAhead, { TypeAheadElement } from "../../TypeAhead";
import { css, jsx } from "@emotion/core";
import { familyHistoryStyles } from "../../../styles/components/ongoing/History/familyHistory"
import AppUtils from "../../../utils/AppUtils";


interface IAddedHistory {
    disease: {
        displayValue: string;
        internalValue: string;
        additionalInfo: any;
    },
    items: Array<{
        comment: string;
        presentDate: string;
        relationship: string;
        tillDate: boolean
    }>,
    q: {
        displayValue: string;
        internalValue: Array<string>;
    },
    updatingMethod: string;
    validSection: boolean;
}

interface IFamilyHistoryProps {
    onTypeAheadChange: (input: string, typeAheadConfig: any) => Promise<any>;
    handleItemChange(updatedItem: any, index: number): void;
    listItems: any[];
}

interface IFamilyHistoryState {
    shouldShowTypeAhead: boolean;
    isReadOnly: boolean;
    selectedItems: Array<IAddedHistory>;
    typeAheadVal: string;
    isMobile: boolean
}



export class FamilyHistory extends React.Component<IFamilyHistoryProps, IFamilyHistoryState> {


    constructor(props: IFamilyHistoryProps) {
        super(props);
        const selectedItems = [...props.listItems.map(({ item }) => item)];
        this.state = {
            shouldShowTypeAhead: selectedItems.length <= 0,
            isReadOnly: selectedItems.length > 0,
            typeAheadVal: "",
            selectedItems,
            isMobile: AppUtils.getIsMobile()
        }
    }

    private relationships: any[] = [{
        "internalValue": "Father",
        "displayValue": "Father"
    }, {
        "internalValue": "Mother",
        "displayValue": "Mother"
    }, {
        "internalValue": "Brother",
        "displayValue": "Brother"
    }, {
        "internalValue": "Sister",
        "displayValue": "Sister"
    }, {
        "internalValue": "Unce",
        "displayValue": "Uncle"
    }, {
        "internalValue": "Aunty",
        "displayValue": "Aunty"
    }, {
        "internalValue": "Paternal Grandfather",
        "displayValue": "Paternal Grandfather"
    }, {
        "internalValue": "Paternal Grandmother",
        "displayValue": "Paternal Grandmother"
    }, {
        "internalValue": "Maternal Grandfather",
        "displayValue": "Maternal Grandfather"
    }, {
        "internalValue": "Maternal Grandmother",
        "displayValue": "Maternal Grandmother"
    }];

    onTypeAheadSelect = (elem: TypeAheadElement, idx?: number, noOfKeystrokes?: number, event?: any, searchKeyword?: string) => {
        const newlyAddedItem: IAddedHistory = {
            disease: {
                displayValue: elem.label,
                internalValue: elem.value,
                additionalInfo: elem.additionalInfoLabel
            },
            items: [{
                comment: undefined,
                presentDate: undefined,
                relationship: undefined,
                tillDate: undefined
            }],
            q: {
                displayValue: elem.label,
                internalValue: [elem.value],
            },
            updatingMethod: "TYPE_AHEAD",
            validSection: true
        }

        const selectedItems = this.state.selectedItems;
        selectedItems.push(newlyAddedItem);
        this.setState({ selectedItems, shouldShowTypeAhead: false });
    }

    onTypeAheadChange = (input: string) => {
        this.setState({ typeAheadVal: input });
        const typeAheadConfig = {
            "source": "MAVERICK",
            "url": "/maverick/care/disease_catalogue",
            "appendQueryString": true,
            "highlightOn": "available",
            "valueKey": "name",
            "labelKey": "name",
            "inputParam": "q",
            "resultMapper": [{
                "internalValue": "internalValue",
                "displayValue": "displayValue"
            }],
            "otherKeysMapping": {
                "on-properties": "id,name",
                "result-size": 20
            },
            "internalKey": "id",
            "code": "uCode"
        }
        return this.props.onTypeAheadChange(input, typeAheadConfig);
    }

    onRelationshipChange = (value: string, ObjectIndex: number, itemIndex: number) => {
        const selectedItems: IAddedHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex]) {
            selectedItems[ObjectIndex].items[itemIndex].relationship = value;
            this.setState({ selectedItems });
        }
    }

    onCommentsChange = (event: React.ChangeEvent<HTMLInputElement>, ObjectIndex: number, itemIndex: number) => {
        const value: string = event.target.value;
        const selectedItems: IAddedHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex]) {
            selectedItems[ObjectIndex].items[itemIndex].comment = value;
            this.setState({ selectedItems });
        }
    }

    addRelationShip = (ObjectIndex: number) => {
        const selectedItems: IAddedHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex]) {
            selectedItems[ObjectIndex].items.push({
                comment: undefined,
                presentDate: undefined,
                relationship: undefined,
                tillDate: undefined
            });
            this.setState({ selectedItems });
        }
    }

    removeRelationShip = (ObjectIndex: number, itemIndex: number) => {
        const selectedItems: IAddedHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex] && itemIndex > 0) {
            selectedItems[ObjectIndex].items.splice(itemIndex, 1);
            this.setState({ selectedItems });
        } else if (selectedItems[ObjectIndex] && itemIndex === 0) {
            selectedItems.splice(ObjectIndex, 1);
            this.setState({ selectedItems });
        }
    }

    addNewDisease = () => {
        this.setState({ shouldShowTypeAhead: true });
    }

    save = () => {
        this.state.selectedItems.forEach((item, index) => {
            this.props.handleItemChange(item, index);
        });
        this.setState({ isReadOnly: true, shouldShowTypeAhead: false });
    }
    edit = () => {
        this.setState({ shouldShowTypeAhead: true, isReadOnly: false });
    }
    render() {
        const { shouldShowTypeAhead, isReadOnly, selectedItems, typeAheadVal } = this.state;
        return <div>
            <button css={familyHistoryStyles.editBtn} onClick={this.edit}>
                <span className="glyphicon glyphicon-pencil" css={familyHistoryStyles.editIcon}></span>
                <span>Edit</span>
            </button>
            {shouldShowTypeAhead &&
                <div css={familyHistoryStyles.commonlyUsedComntainer}>
                    <div>
                        <div>COMMONLY USED</div>
                        <div></div>
                    </div>
                    <div css={familyHistoryStyles.typeAheadContainer}>
                        <TypeAhead value={typeAheadVal} placeholder="Select Disease Name" onTypeAheadChange={this.onTypeAheadChange}
                            onTypeAheadSelect={this.onTypeAheadSelect} />
                    </div>
                </div>
            }
            {!isReadOnly &&
                <div>
                    {
                        selectedItems.map((item: IAddedHistory, ObjectIndex: number) => {
                            let { items } = item;
                            return <div css={familyHistoryStyles.selectedDiseaseRow}>
                                <div css={familyHistoryStyles.verticalMiddle}>{item.disease.displayValue}</div>
                                <div css={familyHistoryStyles.itemsContainer}>
                                    {
                                        items.map(({ comment, tillDate, presentDate, relationship }, itemIndex) => {
                                            const isFatherSelected: boolean = relationship && relationship.toLowerCase() === "father";
                                            const isMotherSelected: boolean = relationship && relationship.toLowerCase() === "mother";
                                            return (
                                                <div css={familyHistoryStyles.itemsWrapper}>
                                                    <div>
                                                        <div css={familyHistoryStyles.groupLabel}>Relationship</div>
                                                        <div css={familyHistoryStyles.relationShipItem}>
                                                            <button onClick={() => this.onRelationshipChange("Father", ObjectIndex, itemIndex)} css={isFatherSelected ? familyHistoryStyles.selectedBtn : familyHistoryStyles.relationshipBtns}>Father</button>
                                                            <button onClick={() => this.onRelationshipChange("Mother", ObjectIndex, itemIndex)} css={isMotherSelected ? familyHistoryStyles.selectedBtn : familyHistoryStyles.relationshipBtns}>Mother</button>
                                                            <CustomSelect dropdownValues={this.relationships} selectedValue={relationship} defaultValue="Relationship" updateDropdownValue={(value) => this.onRelationshipChange(value, ObjectIndex, itemIndex)} />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div css={familyHistoryStyles.groupLabel}>Comments (Optional)</div>
                                                        <div css={familyHistoryStyles.sectionElement}>
                                                            <TextInput placeholder="Comments" value={comment} onChange={(e) => this.onCommentsChange(e, ObjectIndex, itemIndex)} />
                                                        </div>
                                                    </div>
                                                    {!this.state.isMobile && <div css={familyHistoryStyles.actionWrapper}>
                                                        <div>
                                                            {itemIndex === (items.length - 1) &&
                                                                <span className="glyphicon glyphicon-plus-sign" css={familyHistoryStyles.icons} onClick={() => this.addRelationShip(ObjectIndex)}></span>
                                                            }
                                                            {itemIndex !== (items.length - 1) &&
                                                                <span className="glyphicon glyphicon-plus-sign" css={{ ...familyHistoryStyles.icons as any, opacity: 0 }} onClick={() => this.addRelationShip(ObjectIndex)}></span>
                                                            }
                                                            <span className="glyphicon glyphicon-trash" css={familyHistoryStyles.icons} onClick={() => this.removeRelationShip(ObjectIndex, itemIndex)}></span>

                                                        </div>
                                                    </div>}
                                                    {this.state.isMobile && <div css={familyHistoryStyles.actionWrapper}>
                                                        <span className="glyphicon glyphicon-trash" css={familyHistoryStyles.icons} onClick={() => this.removeRelationShip(ObjectIndex, itemIndex)}></span>
                                                    </div>}
                                                    {this.state.isMobile && <div onClick={() => this.addRelationShip(ObjectIndex)}>
                                                        <span className="glyphicon glyphicon-plus-sign" css={{...familyHistoryStyles.icons, color: "#e4306e"}}></span>
                                                        <span style={{color: "#e4306e"}}>Add family member</span>
                                                    </div>}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        })
                    }
                </div>
            }

            {isReadOnly &&
                <div>
                    {
                        selectedItems.map((item: IAddedHistory, ObjectIndex: number) => {
                            let { items } = item;
                            return <div css={familyHistoryStyles.readOnlyRow}>
                                <div css={familyHistoryStyles.verticalMiddle}>{item.disease.displayValue}</div>
                                <div css={familyHistoryStyles.itemsContainer}>
                                    {
                                        items.map(({ comment, tillDate, presentDate, relationship }, itemIndex) => {
                                            return (
                                                <div css={familyHistoryStyles.itemsWrapperReadOnly}>
                                                    {relationship && <div>{relationship} | </div>}
                                                    {comment && <div>{comment} | </div>}
                                                    {tillDate && <div>Present | </div>}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        })
                    }
                </div>
            }
            {!isReadOnly
                &&
                <div css={familyHistoryStyles.bottonCta}>
                    <button onClick={this.addNewDisease} css={familyHistoryStyles.transparentBtn}><span className="glyphicon glyphicon-plus-sign" css={familyHistoryStyles.icons}></span> Add New</button>
                    {selectedItems.length > 0 &&
                        <button css={familyHistoryStyles.selectedBtn} onClick={this.save}>Save</button>
                    }
                </div>
            }

        </div>
    }


}